import React from "react";
import { Check, AlertTriangle, Loader2 } from "lucide-react";

/**
 * Branded confirmation card for the public opt-out pages. Deliberately standalone:
 * no CRM layout, no nav, nothing that assumes a logged-in agent. Mirrors the
 * backend's HTML fallback page so both surfaces look the same.
 */
const OptOutCard = ({ state, title, message }) => {
  const isLoading = state === "loading";
  const isError = state === "error";

  return (
    <div className="min-h-screen bg-[#eef0f2] flex items-start justify-center px-4 py-12">
      <div className="w-full max-w-[480px] bg-white rounded-[10px] shadow-[0_1px_4px_rgba(0,0,0,0.08)] px-8 py-9 text-center">
        <img
          src="/collingslogo-removebg-preview.png"
          alt="Collings Real Estate"
          className="mx-auto w-40 max-w-full h-auto"
        />

        <div
          className={`mx-auto mt-6 w-14 h-14 rounded-full flex items-center justify-center ${
            isLoading ? "bg-gray-300" : isError ? "bg-[#c0392b]" : "bg-[#1ec8c8]"
          }`}
        >
          {isLoading ? (
            <Loader2 className="w-7 h-7 text-white animate-spin" />
          ) : isError ? (
            <AlertTriangle className="w-7 h-7 text-white" />
          ) : (
            <Check className="w-8 h-8 text-white" strokeWidth={3} />
          )}
        </div>

        <h1 className="mt-4 text-xl font-semibold text-[#0d1b2a]">{title}</h1>
        <p className="mt-3 text-[15px] leading-relaxed text-[#444]">{message}</p>

        {!isLoading && (
          <p className="mt-7 text-xs text-gray-500">
            Collings Real Estate Pty Ltd · 230 Waterdale Road, Ivanhoe VIC 3079
            <br />
            (03) 9486 2000 ·{" "}
            <a href="mailto:info@collings.com.au" className="text-[#0d1b2a] underline">
              info@collings.com.au
            </a>
          </p>
        )}
      </div>
    </div>
  );
};

export default OptOutCard;
